import { Accordion, AccordionButton, AccordionIcon, AccordionItem, AccordionPanel, ButtonGroup, Card, Container, ExpandedIndex, Flex, Heading, HStack, Table, Tbody, Td, Text, Tr } from '@chakra-ui/react';
import iconArrowLeftRight from 'assets/icons/icon-arrow-left-right.svg';
import ButtonRemoveResource from 'components/ButtonRemoveResource';
import ActiveTag from 'components/ui/ActiveTag';
import ButtonCreateNew from 'components/ui/ButtonCreateNew';
import EmptyList from 'components/ui/EmptyList';
import IconButtonCreate from 'components/ui/IconButtonCreate';
import IconButtonEdit from 'components/ui/IconButtonEdit';
import { useResourceList } from 'hooks/useResourceList';
import { useParams } from 'react-router-dom';
import TemplateCategoriesProvider, { useTemplateCategoriesContext } from '../contexts/TemplateCategoriesContext';
import ModalCategory from './ModalCategory';
import ModalSubcategory from './ModalSubcategory';


// needed for row & cell level scope DnD setup
import DndSortableList, { DraggableRow, RowDragHandleButton } from 'components/ui/DndSortableList/DndSortableList';
import { useState } from 'react';

type DefaultButtonRemoveProps = {
  pathName: string,
  resourceName: string,
  queryKey: (string| object)[]
}

function ListContentGroupCategories() {
  const { id } = useParams();
  const { onCreateSubcategory, onCreateCategory, onEditCategory, onEditSubcategory } = useTemplateCategoriesContext();

  const [index, setIndex] = useState<ExpandedIndex>();

  const { data: categories } = useResourceList({
    resourceName: 'categories',
    path: 'template-categories',
    params: {
      contentGroupId: id
    }
  });

  if (!categories)
      return null;

  const defaultButtonRemoveProps: DefaultButtonRemoveProps = {
    pathName: 'template-categories',
    resourceName: 'categories',
    queryKey: [
      'categories', 
      { contentGroupId: id }
    ] 
  }

  return (
    <Container 
      variant="internal"
      flexDirection="column" 
      pb="80px"
    >
      <ModalCategory />
      <ModalSubcategory />
    
      <Flex justifyContent="space-between">
        <Heading as="h1" size="h1">
          Categorias do Modelo
          <span>Visualize a lista de Modelos de Disparo e Produtos Patri</span>
        </Heading>

        <ButtonCreateNew 
          title="Cadastrar nova"
          onClick={onCreateCategory}
        />
      </Flex>

      <Card w="full" p="40px" mt="53px">
        <Accordion 
          allowToggle 
          index={index}
          onChange={setIndex}
        >
          <DndSortableList data={categories} onDragStart={() => setIndex(-1)}>
            {({ sortedData }) => {
              
            return sortedData?.map(category => (
              <DraggableRow 
                key={`category-${category.id}`} id={category.id}>
                <AccordionItem borderTop="none" borderColor="#E2E8F0">
                {({ isExpanded }) => (
                  <>
                    <HStack>
                      <RowDragHandleButton rowId={category.id} />
                      
                      <AccordionButton py="20px">
                        <AccordionIcon mr="8px" />
                        <Text as="span" fontSize="14px">{category.name}</Text>
                        { !category.active && <ActiveTag isActive={category.active} ml="auto" /> }
                      </AccordionButton>

                      <ButtonGroup> 
                        { isExpanded && <IconButtonCreate onClick={onCreateSubcategory(category)} /> }
                        <IconButtonEdit onClick={onEditCategory(category)} />
                        <ButtonRemoveResource 
                          id={category.id} 
                          {...defaultButtonRemoveProps}
                        />
                      </ButtonGroup>
                    </HStack>

                    <AccordionPanel>
                    { isExpanded && (
                      <DndSortableList data={category.subcategories}>
                        {({ sortedData: subcategories }) => (
                        <Table ml="30px" w="full">
                          <Tbody>
                          { subcategories.map(subcategory => (
                            <DraggableRow 
                              key={`subcategory-${subcategory.id}`} 
                              id={subcategory.id}
                              as={Tr}
                            >
                              <Td w="25px">
                                <RowDragHandleButton rowId={subcategory.id} />
                              </Td>
                              <Td>
                                <HStack spacing="20px" w="full">
                                  <Text>{subcategory.name}</Text>
                                  <HStack ml="auto">
                                    { !subcategory.active && <ActiveTag isActive={subcategory.active} /> }

                                    <ButtonGroup>
                                      <IconButtonEdit onClick={onEditSubcategory(subcategory, category)} />
                                      <ButtonRemoveResource 
                                        id={subcategory.id} 
                                        {...defaultButtonRemoveProps}
                                      />
                                    </ButtonGroup>
                                  </HStack>
                                </HStack>  
                              </Td>
                            </DraggableRow>
                          ))}
                          </Tbody>
                        </Table>
                      )}
                      </DndSortableList>
                    )}
                    </AccordionPanel>
                  </>
                  )}
                </AccordionItem>
              </DraggableRow>
            ))}} 
          </DndSortableList>
        </Accordion>
        
      { categories && categories.length === 0 && (
        <EmptyList 
          icon={iconArrowLeftRight}
          title={'Esse modelo de disparo ainda não possui nenhuma categoria cadastrada'}
          description={'Use o botão acima para cadastrar'}
          isTable 
        />
      )}
        
      </Card>
    </Container>
  )
}

export default function ListContentGroupCategoriesWrapper() {
  return (
    <TemplateCategoriesProvider>
      <ListContentGroupCategories />
    </TemplateCategoriesProvider>
  )
} 
